// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import React, { useContext } from "react";
import { isSignedIn, useAuthState } from "store/auth";

import AuthenticationCard from "./AuthenticationCard";
import { CustomerContext } from "components/App/DashboardApp";
import PageContent from "../ui/PageContent";
import Paragraph from "components/ui/Paragraph";
import SignOutButton from "./SignOutButton";

export default () => {
  const authState = useAuthState();
  const customerConfig = useContext(CustomerContext);

  return (
    <PageContent>
      <AuthenticationCard title="Access not allowed">
        <div>Your account does not have access to {customerConfig.name}.</div>
        {isSignedIn() && (
          <>
            <Paragraph>
              Currently signed in as: {authState.auth?.email}
            </Paragraph>

            <SignOutButton />
          </>
        )}
      </AuthenticationCard>
    </PageContent>
  );
};
